<template>
<div class="productList">
  <slot name="header" />

  <b-table :items="data" :fields="fields" striped hover small outlined>
    <template v-slot:cell(actions)="row">
      <b-button-group size="sm" class="float-right">
         <span v-b-tooltip.hover v-if="authenticated" title="Rediger" @click="showedit(row.item)">
          <v-icon name="pen" />
        </span>&nbsp;
        <span v-b-tooltip.hover v-if="authenticated" title="Fjern" @click="showdelete(row.item)">
          <v-icon name="trash-alt" />
        </span>&nbsp;
        <span v-b-tooltip.hover title="Mere info" @click.stop="row.toggleDetails">
          <v-icon v-if="row.detailsShowing" color="green" name="chevron-circle-up" />
          <v-icon v-if="!row.detailsShowing" color="green" name="chevron-circle-down" />
        </span>
      </b-button-group>

    </template>
    <template slot="row-details" slot-scope="row">
      <b-card>
        {{ row.item.description }}
      </b-card>
    </template>
  </b-table>
  <EditItem ref="editItem" />
  <RemoveItem ref="removeItem" />
</div>
</template>

<script>
import {
  db
} from '../../config/firebase';

import EditItem from './Edit'
import RemoveItem from './Remove'
import 'vue-awesome/icons/pen'
import 'vue-awesome/icons/trash-alt'
import 'vue-awesome/icons/chevron-circle-down'
import 'vue-awesome/icons/chevron-circle-up'
import Icon from 'vue-awesome/components/Icon'

export default {
  name: 'Product',
  components: {
    EditItem,
    RemoveItem,
    'v-icon': Icon
  },
  props: {
    fields: {
      type: Array,
      required: true
    },
    data: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      selected: '',
      selectedItem: {
        category: '',
        group: '',
        type: '',
        description: '',
        price: ''
      }
    }
  },
  computed: {
    authenticated() {
      return this.$store.state.authenticated;
    }
  },
  firebase: {
    products: db.ref('products')
  },
  methods: {
    showedit(item) {
      this.$refs.editItem.show(item)
    },
    showdelete(item) {
      this.$refs.removeItem.show(item)
    }
  }
}
</script>

<style scoped>
.productList {
  padding: 25px 0px 25px 0px;
}
</style>
